module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_682.3e1d85a4.jpg";